export enum UnsupportedContactType {
    NA = 0,
    CallQueueOrAutoAttendant = 1,
    IVRQueue = 2,
    IVRFlow = 3,
}